import { render, staticRenderFns } from "./QScoreCard.vue?vue&type=template&id=ccd3ab2c&scoped=true&"
import script from "./QScoreCard.vue?vue&type=script&lang=js&"
export * from "./QScoreCard.vue?vue&type=script&lang=js&"
import style0 from "./QScoreCard.vue?vue&type=style&index=0&id=ccd3ab2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd3ab2c",
  null
  
)

export default component.exports